module.exports = __webpack_public_path__ + "img/trial-to-basic-group.d78fa7f0.svg";